import React, { FC, ReactNode } from "react";
import "./style.scss";

interface TitleProps {
  level?: "1" | "2" | "3" | "4";
  children: ReactNode;
  className?: string;
}

const TextCallout: FC<TitleProps> = ({
  level = "large",
  children,
  className = "",
}) => {
  return <div className={`callout-${level} ${className}`}>{children}</div>;
};

export default TextCallout;
